import { ChevronRightIcon } from '@chakra-ui/icons'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Center,
  Container,
  Flex,
  Input,
  Select,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'
import { collection, getDocs, orderBy, query, where } from 'firebase/firestore'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { search } from 'ss-search'
import { db } from '../../config/firebase'

function Fillable() {
  const history = useHistory()
  const [formList, setFormList] = useState([])
  const [filterType, setFilterType] = useState('All')
  const [filterStatus, setFilterStatus] = useState('Active')
  const [isLoading, setLoading] = useState(true)
  const [onSearch, setOnSearch] = useState('')
  // const params = useParams()

  function handleSearch(e) {
    const searchTerm = e.target.value
    setOnSearch(searchTerm)
  }
  useEffect(() => {
    fetchForm()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterType, onSearch, filterStatus])

  const fetchForm = async () => {
    setLoading(true)

    // Build query based on filters
    const formRef = collection(db, 'Form')
    const conditions = []

    // Add type filter if not 'All'
    if (filterType !== 'All') {
      conditions.push(where('type', '==', filterType))
    }

    // Add status filter if not 'All'
    if (filterStatus !== 'All') {
      conditions.push(where('status', '==', filterStatus))
    }

    // Always add order by createdAt
    conditions.push(orderBy('createdAt', 'desc'))

    // Execute query
    const qForm = query(formRef, ...conditions)
    const formSnapshot = await getDocs(qForm)

    // Process results
    const formData = formSnapshot.docs.map(doc => ({
      ...doc.data(),
      id: doc.id,
    }))

    // Apply search filter if needed
    const searchKeys = ['namePatient', 'patient', 'person', 'type', 'createdAt']
    const searchResults = onSearch
      ? search(formData, searchKeys, onSearch)
      : formData

    setFormList(searchResults)
    setLoading(false)
  }
  return (
    <>
      <Container maxW="100%" mt="5">
        <Breadcrumb
          spacing="8px"
          separator={<ChevronRightIcon color="gray.500" />}
          bg="gray.100"
          p="1.5"
          borderRadius="0.3em"
        >
          <BreadcrumbItem>
            <BreadcrumbLink as={Link} to="/dashboard">
              Dashbaord
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <BreadcrumbLink as={Link} to="/fillable">
              Patient Form
            </BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>
        <Center mt="5" flexDirection="column" alignItems="flex-start">
          <Flex w="100%" justifyContent="space-between">
            <Input
              w="400px"
              type="text"
              onChange={handleSearch}
              placeholder="Search"
            />
            <Flex gap="1rem">
              <Select
                value={filterType}
                onChange={e => setFilterType(e.target.value)}
              >
                <option value="All">All</option>
                <option value="WebEnableForm">Web Enable Form</option>
                <option value="NonWebEnableForm">Non WebEnable Form</option>
                <option value="NewPatientPacket">New Patient Packet</option>
                <option value="MedicalRecord">Medical Record</option>
              </Select>
              <Select
                value={filterStatus}
                onChange={e => setFilterStatus(e.target.value)}
              >
                <option value="All">All</option>
                <option value="Active">Active</option>
                <option value="Archived">Archived</option>
              </Select>
            </Flex>
          </Flex>
          {isLoading ? (
            <Center w="100%" pt="5rem">
              <span className="loader"></span>
            </Center>
          ) : (
            <TableContainer w="100%" mt="5">
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th>NAME</Th>
                    <Th>TYPE</Th>
                    <Th>CREATED DATE</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {formList.map((e, i) => {
                    return (
                      <Tr
                        key={i}
                        onClick={() => {
                          history.push(`/fillable/view/${e.id}`)
                        }}
                        cursor="pointer"
                      >
                        <Td>{e.namePatient || e.namepatientForm3}</Td>
                        <Td>{switchType(e.type)}</Td>
                        <Td>
                          {moment(e.createdAt.toDate()).format('yyyy-MM-DD')}
                        </Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          )}
        </Center>
      </Container>
    </>
  )
}

export default Fillable

function switchType(message) {
  switch (message) {
    case 'WebEnableForm':
      return 'Web Enable Form'
    case 'NonWebEnableForm':
      return 'Non Web Enable Form'
    case 'NewPatientPacket':
      return 'New Patient Packet'
    case 'MedicalRecord':
      return 'Medical Record'
    default:
      return message
  }
}
